<script setup>
import { onMounted, computed, ref } from "vue";
import { Checkbox, Input, ProfilePicture } from "@components";

import { useStaff } from "@store/staff";
const $staff = useStaff();

import { useServiceItem } from "@store/serviceItem";
const $serviceItem = useServiceItem();

import { useSettings } from "@store/settings";
const $settings = useSettings();

const filter = ref({
	searchStaff: "",
});

const filteredStaff = computed(() => {
	let filteredArray = $staff.getStaffs;
	if (!filteredArray) return [];
	// filter only publish staffs
	filteredArray = filteredArray.filter(
		(staff) => !staff.meta.status || staff.meta.status === "publish"
	);

	// Filter by search
	if (filter.value.searchStaff) {
		filteredArray = filteredArray.filter((staff) =>
			String(staff.name)
				.toLowerCase()
				.includes(filter.value.searchStaff?.toLowerCase())
		);
	}
	return filteredArray;
});

const toggleStaff = (staffId) => {
	$serviceItem.service.staffs = $serviceItem.service.staffs || [];
	const index = $serviceItem.service.staffs.indexOf(staffId);
	if (index > -1) {
		$serviceItem.service.staffs.splice(index, 1);
	} else {
		$serviceItem.service.staffs.push(staffId);
	}
};

const isStaffSelected = (staffId) => {
	if (!$serviceItem.service.staffs) return false;
	return $serviceItem.service.staffs.includes(staffId);
};
</script>

<template>
	<div>
		<div class="w-full mb-5">
			<Input v-model="filter.searchStaff" class="w-full" placeholder="Search by name" iconLeft="searchLg"></Input>
		</div>
		<div v-if="$serviceItem.state.loading" class="flex gap-3">
			<div v-for="i in 4" class="animate-pulse bg-[#F2F4F7] rounded-md h-[130px] w-[163px]"></div>
		</div>
		<div v-else class="grid items-center grid-cols-2 md:grid-cols-4 gap-3">
			<!-- Staff List -->
			<div v-for="(staff, index) in filteredStaff" :key="index" :title="staff.name" @click.prevent="toggleStaff(staff.staff_id)" class="h-full cursor-pointer relative flex flex-col border p-4 rounded-lg transition border-solid border-[#EAECF0] w-full md:w-[163px]" :class="{ 'opacity-70': !isStaffSelected(staff.staff_id) }">
				<ProfilePicture :name="staff.name" :img="staff.meta.profile_image_url" :bgColor="staff.meta?.color" class="mb-4 w-14 h-14" />
				<div class="text-[#344054] text-base font-semibold w-full truncate">{{ staff.name }}</div>
				<Checkbox id="team" :checked="isStaffSelected(staff.staff_id)" class="absolute pointer-events-none top-4" :class="$settings.isRTL ? 'left-4' : 'right-4'" />
			</div>
			<div v-if="filteredStaff.length == 0" class="w-full text-[red]">No staff found</div>
		</div>
	</div>
</template>



<style>
</style>